import type { ResultSet } from 'react-native-sqlite-storage';
import { getFirstResultRow, mapResultRows } from './offlineDatabase.rows';

export function stringifyCacheData<T>(value: T): string {
  return JSON.stringify(value);
}

export function parseCacheData<T>(value: string): T {
  return JSON.parse(value) as T;
}

export function mapCachedDataRows<T>(result: ResultSet, columnName = 'data'): T[] {
  return mapResultRows<T>(result, (row) => parseCacheData<T>(row[columnName]));
}

export function getCachedDataRow<T>(result: ResultSet, columnName = 'data'): T | null {
  const row = getFirstResultRow(result);

  if (!row) {
    return null;
  }

  return parseCacheData<T>(row[columnName]);
}
